export const LABELS = {
    HEADER: 'Com o Open Insurance, você sai ganhando!',
    DESCRICAO:
        'A gente identificou que você está solicitando o compartilhamento dos seus dados por meio Open Insurance (Sistema de Seguros Aberto). Para dar continuidade e finalizar o processo, basta inserir o CPF vinculado ao CNPJ da sua conta.',
    CPF: 'CPF',
    BTN_SAIR: 'SAIR',
    BTN_SUBMIT: 'Continuar',
    BTN_TENTAR_NOVAMENTE: 'TENTAR NOVAMENTE',
    BTN_VOLTAR: 'VOLTAR',
    HEADER_ERRO_VALIDAR_CPF: 'Algo deu errado',
    MSG_ERRO_VALIDAR_CPF:
        'A gente identificou que você solicitou o compartilhamento das suas informações para outra instituição. No entanto, o CPF e/ou CNPJ informado não confere com o utilizado para  acessar a conta. Por favor, confira os dados e tente novamente.',
    CPF_MISMATCH:
        'A gente identificou que você solicitou o compartilhamento das suas informações para outra instituição. No entanto, o CPF informado não confere com o utilizado para acessar a conta. Por favor, confira os dados e tente novamente.',
    CNPJ_MISMATCH:
        'A gente identificou que você solicitou o compartilhamento das suas informações para outra instituição. No entanto, o CPF e/ou CNPJ informado não confere com o utilizado para acessar a conta. Por favor, confira os dados e tente novamente.',
    GENERIC_ERROR:
        'Lamentamos informar que sua solicitação não foi concluída. Por favor, verifique as informações e tente novamente.',
    EXPIRED_CONSENT:
        'Sua sessão expirou, por favor, tente novamente em outro momento.',
};

export const FIELDS = {
    CPF: 'cpf',
};

export const OPUS_ERROR_ENUM = {
    CPF_MISMATCH: 'CPF_MISMATCH',
    CNPJ_MISMATCH: 'CNPJ_MISMATCH',
    EXPIRED_CONSENT: 'EXPIRED_CONSENT',
    GENERIC_ERROR: 'GENERIC_ERROR',
};
